import { MutationTree } from 'vuex';
import { Site } from '@/models/Site';
import { CONTACT } from './mutation-types';
import { ContactState, initialState as resetState } from './state';
import { Interlocuteur } from '@/models/Interlocuteur';

export const mutations: MutationTree<ContactState> = {

    [CONTACT.SET_SITE](state, site: Site) {
        state.interlocuteurs = [];
        state.interlocuteur = undefined;
        state.site = site;
    },

    [CONTACT.SET_INTERLOCUTEUR](state, interlocuteur: Interlocuteur) {
        state.interlocuteur = interlocuteur;
    },

    [CONTACT.SET_OBJET](state, objet: string) {
        state.objet = objet;
    },

    [CONTACT.SET_DESCRIPTION](state, description: string) {
        state.description = description;
    },

    [CONTACT.SET_LISTE_INTERLOCUTEURS](state, interlocuteurs: Interlocuteur[]) {
        state.interlocuteurs = interlocuteurs;
    },

    [CONTACT.NEXT_STEP](state) {
        state.step += 1;
    },

    [CONTACT.PREVIOUS_STEP](state) {
        state.step -= 1;
    },

    [CONTACT.SET_INTERLOCUTEURS_LOADING](state: ContactState, isLoadingInterlocuteurs: boolean): void {
        state.isLoadingInterlocuteurs = isLoadingInterlocuteurs;
    },

    [CONTACT.SET_MESSAGE_SENDING](state: ContactState, isSendingMessage: boolean): void {
        state.isSendingMessage = isSendingMessage;
    },

    [CONTACT.SET_IS_SUCCESS](state: ContactState, isSuccess: boolean): void {
        state.isSuccess = isSuccess;
    },

    [CONTACT.RESET](state) {
        Object.assign(state, resetState);
    },
    [CONTACT.EXPORT_LOADING](state: ContactState, isLoading: boolean): void {
        state.exportLoading = isLoading;
    },
};
